module.exports = __webpack_public_path__ + "img/shield.82ff8fb0.svg";